import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Row,
  Col,
  message,
  Modal,
  Divider,
  Form,
  Input,
  Button,
  Radio,
  Alert,
  Switch,
  Tooltip,
  InputNumber,
  Steps,
  Select,
  notification,
} from "antd";
import {
  QuestionCircleOutlined,
  SaveOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { generateProposals } from "apis/gpt";
import { useGetAdviseeDetails } from "apis/advisee";
import { PrimaryColor } from "utils/constants";

const SolutionsForm = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [expandAdvanceOptions, setExpandAdvanceOptions] = useState(true);
  const [policyList, setPolicyList] = useState([
    // {
    //   label: "Policy 1",
    //   value: "Policy 1",
    // },
    // {
    //   label: "Policy 2",
    //   value: "Policy 2",
    // },
    // {
    //   label: "Policy 3",
    //   value: "Policy 3",
    // },
    // {
    //   label: "Policy 4",
    //   value: "Policy 4",
    // },
    // {
    //   label: "Policy 5",
    //   value: "Policy 5",
    // },
  ]);
  const [policiesReplaceList, setPoliciesReplaceList] = useState([]);
  const [policiesConsolidateList, setPoliciesConsolidateList] = useState([]);
  const [policiesRemoveList, setPoliciesRemoveList] = useState([]);

  const [gptModels, setGptModels] = useState([]);

  const { id: adviseeId } = useParams();

  const {
    isLoading: isAdviseeDetailsLoading,
    data: personalDetails,
  } = useGetAdviseeDetails(adviseeId, {});

  // console.log("solutionsForm personalDetails", personalDetails);

  useEffect(() => {
    if (personalDetails) {
      const policies = personalDetails.policies.map((item) => {
        return {
          label: item.name,
          value: item._id,
        };
      });

      setPolicyList(policies);
    }

    return () => {};
  }, [personalDetails]);

  const handleGenerateProposal = async (values) => {
    notification.info({
      message: "Generating Solutions, Please wait...",
    });
    props.createSolution({
      ...values,
      enableAdvanceOptions: !expandAdvanceOptions,
    });
  };

  const onFinish = (values) => {
    setLoading(true);

    // const res = await FleetApi.addEditFleet(
    //   formData,
    //   userId ? "patch" : "post",
    //   userId
    // );

    // console.log("res", res);

    setLoading(false);

    // if (res.status !== "error") {
    message.success("Customize Tools Saved!");
    // }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed to login", errorInfo);
  };

  const formLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 4 },
      xl: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 16 },
      xl: { span: 16 },
    },
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 24 },
      xl: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 24 },
      xl: { span: 24 },
    },
  };

  return (
    <div>
      <div>
        <Form
          form={form}
          autoComplete="off"
          layout="vertical"
          // colon={false}
          hideRequiredMark
          {...formItemLayout}
          // onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          initialValues={{
            policiesReplace: [],
            policiesConsolidate: [],
            policiesRemove: [],
          }}
        >
          <Form.Item
            label="Prompt"
            name="prompt"
            rules={[
              {
                required: expandAdvanceOptions,
                message: "Prompt is required",
              },
            ]}
            initialValue={"Let's start generate solutions."}
          >
            <Input.TextArea
              disabled={loading}
              autoSize={{
                minRows: 2,
                maxRows: 2,
              }}
              maxLength={300}
              placeholder="I want to create a solution for my clients that focused on improving his CI cover to >100%"
            />
          </Form.Item>

          <Button
            type="link"
            style={{
              color: PrimaryColor,
              paddingLeft: 0,
            }}
            onClick={() => {
              setExpandAdvanceOptions(!expandAdvanceOptions);
            }}
            icon={expandAdvanceOptions ? <DownOutlined /> : <UpOutlined />}
          >
            Advance Options
          </Button>

          {!expandAdvanceOptions && (
            <Row>
              <Col span={16}>
                <Row>
                  <Col span={12}>
                    <Form.Item
                      label="Death Cover"
                      name="deathCover"
                      rules={[
                        {
                          required: true,
                          message: "Death Cover is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="TPD Cover"
                      name="TPDCover"
                      rules={[
                        {
                          required: true,
                          message: "TPD Cover is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Accidental Death"
                      name="accidentalDeathCover"
                      rules={[
                        {
                          required: true,
                          message: "Accidental Death is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Accidental TPD"
                      name="accidentalTPDCover"
                      rules={[
                        {
                          required: true,
                          message: "Accidental TPD is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Critical Illness"
                      name="ciCover"
                      rules={[
                        {
                          required: true,
                          message: "Critical Illness is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Early CI"
                      name="earlyCICover"
                      rules={[
                        {
                          required: true,
                          message: "Early CI is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label="Medical Card"
                      name="medicalCardCover"
                      rules={[
                        {
                          required: true,
                          message: "Medical Card is required",
                        },
                      ]}
                      initialValue={3}
                      hidden={expandAdvanceOptions}
                    >
                      <Radio.Group disabled={loading}>
                        <Radio value={0}>0</Radio>
                        <Radio value={1}>1</Radio>
                        <Radio value={2}>2</Radio>
                        <Radio value={3}>3</Radio>
                        <Radio value={4}>4</Radio>
                        <Radio value={5}>5</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              <Col
                span={8}
                style={{
                  display: !expandAdvanceOptions ? "block" : "none",
                }}
              >
                0 – GPT will not try to improve at all <br />1 – GPT may only
                consider this slight at the final option <br />2 – GPT may add
                this at the final option <br />3 – GPT will include this on 2nd
                and 3rd option <br />4 – GPT may add this area slightly on 2nd
                option <br />5 – GPT focus on improving this cover first
              </Col>
            </Row>
          )}
        </Form>

        <Row justify="end">
          <Button
            size="large"
            type="primary"
            style={
              {
                // width: 120,
              }
            }
            icon={<SaveOutlined />}
            onClick={async () => {
              const values = await form.validateFields();
              console.log(values);

              Modal.confirm({
                title: "Confirm Generate Proposals?",
                onOk: async () => {
                  handleGenerateProposal(values);
                },
              });
            }}
            loading={loading}
          >
            Generate Solutions
          </Button>
        </Row>
      </div>
    </div>
  );
};

export default SolutionsForm;
